<template>
  <div>
    <b-list-group v-if="meetings.length > 0">
      <b-list-group-item v-for="meeting in meetings" :key="meeting.meetingId">
        {{ meeting.name }}<br />
        {{ formatMeetingDate(meeting) }} <br />
        <div v-if="meeting.joinUrl">
          Join Url: <a :href="meeting.joinUrl">Click here</a>
          <b-button
            class="float-right"
            size="sm"
            :disabled="linkCopied"
            v-clipboard:copy="meeting.joinUrl"
            v-clipboard:success="onCopy"
          >
            {{ !linkCopied ? "Copy link" : "Copied!" }}
          </b-button>
        </div>
      </b-list-group-item>
    </b-list-group>
    <div v-if="!(meetings.length > 0)" style="margin: 20px">
      <p>{{ noneText }}</p>
    </div>
    <AddMeetingModal
      ref="add-meeting-modal"
      @submit="addMeetingSubmit"
      :projectId="projectId"
      :users="users"
    >
    </AddMeetingModal>
  </div>
</template>

<script>
import AddMeetingModal from "@/modal-components/AddMeetingModal.vue";

export default {
  components: {
    AddMeetingModal,
  },
  props: {
    meetings: { type: Array, default: () => [] },
    projectId: String,
    users: { type: Array, default: () => [] },
    showAll: { type: Boolean, default: false },
    noneText: { type: String, default: "No Meetings" },
    title: { type: String, default: "Meetings" },
    allowAdd: { type: Boolean, default: false },
    onlyAddOne: { type: Boolean, default: false },
    meetingAdded: { type: Boolean, default: false },
  },
  data() {
    return {
      errors: [],
      linkCopied: false,
    };
  },
  methods: {
    formatMeetingDate(meeting) {
      if (meeting.start && meeting.end) {
        return (
          new Date(meeting.start).toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
          }) +
          " - " +
          new Date(meeting.end).toLocaleString("en-US", {
            hour: "numeric",
            minute: "2-digit",
          })
        );
      } else if (meeting.meetingDate) {
        return new Date(meeting.meetingDate).toLocaleString("en-US", {
          month: "numeric",
          day: "numeric",
          year: "numeric",
        });
      } else {
        return "";
      }
    },
    addMeeting() {
      this.$refs["add-meeting-modal"].show();
    },
    addMeetingSubmit() {
      this.$emit("update");
      this.$refs["add-meeting-modal"].cancel();
    },
    onCopy() {
      this.linkCopied = true;
    },
  },
  computed: {
    displayableMeetings() {
      return this.showAll ? this.meetings : this.meetings.slice(0, 5);
    },
  },
};
</script>